import React, { useRef } from 'react';
import styled from 'styled-components';

import GetAppSection from 'modules/corporateOffer/components/GetAppSection';
import SuccessStoriesSection from 'modules/corporateOffer/components/sections/SuccessStoriesSection';
import StickyHeader from 'modules/corporateOffer/components/StickyHeader';
import SuccessHeroSection from 'modules/corporateOffer/components/SuccessHeroSection';
import WebsiteFooter from 'modules/corporateOffer/components/WebsiteFooter';
import { useCorporateContext } from 'modules/corporateOffer/CorporateContext';

export const CorporateOfferSuccess = () => {
  const { userName } = useCorporateContext();

  const successRef = useRef<HTMLDivElement>(null);

  return (
    <Container>
      <StickyHeader />
      <SuccessHeroSection userName={userName} />

      <GetAppSection
        goToNextSection={() =>
          successRef.current?.scrollIntoView({ behavior: 'smooth' })
        }
      />
      <SuccessStoriesSection
        ref={successRef}
        title="Trusted by 1000’s of people like you"
        withSubtitle={false}
        withFooter={false}
      />
      <WebsiteFooter withGetAppSection={false} />
    </Container>
  );
};

const Container = styled.main`
  width: 100%;
  position: relative;
  overflow: hidden;
`;
